import React from "react";
import {Button} from "@mui/material";
import type {ButtonBaseProps} from "@mui/material";

interface ButtonInterface extends ButtonBaseProps  {
  title?: any;
  type?: "submit" | "reset" | "button" | undefined;
  onClick?: any;
  className?: string;
  disabled?: boolean;
  bgColor?: string;
  textColor?: string;
  variant?: "text" | "outlined" | "contained";
}
const CustomButton = ({
  title,
  type,
  onClick,
  className,
  disabled = false,
  bgColor = "bg-sidebarSelectText",
  textColor = "text-white",
  variant = "contained",
}: ButtonInterface) => {
  return (
    <Button
      className={`${className} ${bgColor} ${textColor} flex items-center justify-center px-8 py-2 rounded-md sm:w-auto w-full capitalize disabled:cursor-not-allowed disabled:opacity-80`}
      type={type}
      onClick={onClick}
      disabled={disabled}
      variant={variant}
    >
      {title}
    </Button>
  );
};
export default CustomButton as React.FC<ButtonInterface>;
